import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzCardModule } from '@blk/daisy/modules/cards';

import { CardWrapperComponent } from './card-wrapper.component';


@NgModule({
	declarations: [
		CardWrapperComponent
	],
	imports: [
		CommonModule,
		DzCardModule
	],
	exports: [
		CardWrapperComponent
	]
})
export class CardWrapperModule { }
